import { IonCol, IonContent, IonGrid, IonHeader, IonList, IonMenu, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { PropsWithChildren, ReactNode, RefObject } from 'react';
import { useIntl } from 'react-intl';

import styles from '@components/menus/Menu.module.css';
import InternalLink from '@components/typography/InternalLink';
import useMyExpert from '@hooks/useMyExpert';
import { imageUrl } from '@utils/imageUtils';
import { journeyRoute } from '@utils/routeUtils';

type Props = PropsWithChildren<{
  hidden?: boolean;
  journeyId: string;
  leftSection?: ReactNode;
  menuRef: RefObject<HTMLIonMenuElement>;
  mobileHidden?: boolean;
}>;

const Menu = ({ children, hidden = false, journeyId, leftSection, menuRef, mobileHidden = false }: Props) => {
  const intl = useIntl();
  const myExpert = useMyExpert();

  return (
    <IonMenu
      className={`${styles.menu} ${hidden ? styles.hidden : ''} ${mobileHidden ? styles.mobileHidden : ''}`}
      contentId="main"
      data-test="menu"
      ref={menuRef}
    >
      <IonGrid className="ion-no-padding ion-no-margin">
        <IonRow>
          {leftSection && (
            <IonCol className={styles.leftSection} size="auto">
              <IonContent className={styles.leftSectionWidth}>{leftSection}</IonContent>
            </IonCol>
          )}
          <IonContent className={styles.menuContent}>
            <IonCol>
              <IonHeader className={`${styles.header} ion-no-border`} role="">
                <IonToolbar className={styles.toolbar}>
                  <IonTitle>
                    <div className={styles.logoContainer}>
                      <InternalLink
                        aria-label={intl.formatMessage({ id: 'menus.client.carePlan' })}
                        expand
                        stylized={false}
                        to={journeyRoute({
                          journeyId,
                          linkAfterJourney: '/care-plan',
                          myExpert
                        })}
                      >
                        <img
                          alt={intl.formatMessage({ id: 'accessibility.altTags.whiteLogo' })}
                          className={styles.logo}
                          src={imageUrl('logoPureWhite')}
                        />
                      </InternalLink>
                    </div>
                  </IonTitle>
                </IonToolbar>
              </IonHeader>

              <IonList className={styles.primaryNav}>{children}</IonList>
            </IonCol>
          </IonContent>
        </IonRow>
      </IonGrid>
    </IonMenu>
  );
};

export default Menu;
